import TimelineActivity from "~/components/drawers/timeline/activity";

class TimelineActivityOwnerChange extends TimelineActivity {}

const ownerChangedTitle = (activity) => {
  const previousOwnerName = activity.parameters?.previous_owner_name;
  const ownerName = activity.parameters?.owner_name;

  if (activity.key === "lead.owner_assigned") {
    return ownerName ? `Owner set to ${ownerName}` : "Owner set";
  }

  if (activity.key === "lead.owner_removed") {
    return previousOwnerName
      ? `Owner removed. Previous owner: ${previousOwnerName}`
      : "Owner removed";
  }

  if (previousOwnerName && ownerName) {
    return `Owner changed from ${previousOwnerName} to ${ownerName}`;
  }

  return "Owner changed";
};

TimelineActivityOwnerChange.defaultProps = {
  title: (obj) => {
    return ownerChangedTitle(obj.props.activity);
  },
  icon: "user-tag",
  prefix: "fas",
  alwaysPublic: false,
};

export { ownerChangedTitle };
export default TimelineActivityOwnerChange;
